<div class="space-y-6 pb-20 sm:pb-8">
  <!-- Top Header & Balances (Material Surface) -->
  <div
    class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-white dark:bg-slate-900 p-4 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md transition-colors">
    <div class="flex items-center gap-3.5 min-w-0">
      <button
        type="button"
        (click)="game.openClubShieldEditor()"
        id="btn-club-shield-customize"
        aria-label="Personalizar escudo"
        title="Personalizar el escudo, colores y siglas del club"
        class="w-12 h-14 flex items-center justify-center shrink-0 rounded-lg cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-500 transition-colors"
      >
        <app-club-shield [club]="game.userClub()" size="lg" />
      </button>
      <div class="min-w-0">
        <div class="flex items-center space-x-2 flex-wrap">
          <h2 class="text-xl font-bold text-slate-900 dark:text-white truncate">{{ game.userClub().name }}</h2>
          <span
            class="px-2 py-0.5 rounded-lg text-xs font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
            {{ game.userClub().division || game.t('stadium.badge') }}
          </span>
        </div>
        <div class="flex items-center gap-2.5 mt-1 flex-wrap">
          <p class="text-xs text-slate-500 dark:text-slate-400">
            {{ game.t('stadium.desc') }}
          </p>
          <button
            type="button"
            (click)="game.openClubShieldEditor()"
            id="btn-customize-club-shield"
            class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-800 dark:bg-emerald-950/60 dark:hover:bg-emerald-900/60 dark:text-emerald-300 border border-emerald-300/80 dark:border-emerald-700 text-[11px] font-bold cursor-pointer transition-colors shadow-2xs"
            title="Personalizar el escudo, colores y siglas del club"
          >
            <app-icon name="shield" [size]="13" />
            <span>Personalizar escudo</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Balances Pill: Club Financial Indicators only -->
    <div class="flex flex-wrap items-center gap-2.5">
      <div
        class="bg-slate-50 dark:bg-slate-950 px-3.5 py-2 rounded-xl border border-slate-200 dark:border-slate-800 shadow-xs flex-1 sm:flex-initial min-w-[130px]">
        <div class="text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400">{{ game.t('stadium.treasury') }}
        </div>
        <div class="text-sm sm:text-base font-bold text-emerald-700 dark:text-emerald-400 font-mono">
          {{ game.balanceData() ? ((game.balanceData()!.availableBalance / 1000000).toFixed(2) + ' M€') : '—' }}
        </div>
      </div>

      <div
        class="bg-slate-50 dark:bg-slate-950 px-3.5 py-2 rounded-xl border border-slate-200 dark:border-slate-800 shadow-xs flex-1 sm:flex-initial min-w-[130px]">
        <div class="text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400">{{
          game.t('stadium.reserved_funds') }}</div>
        <div class="text-sm sm:text-base font-bold text-slate-700 dark:text-slate-300 font-mono">
          {{ game.balanceData() ? ((game.balanceData()!.reservedBalance / 1000000).toFixed(2) + ' M€') : '—' }}
        </div>
      </div>
    </div>
  </div>

  <!-- Navigation Canonical Tabs (Estadio, Staff, Economía, Sponsors) -->
  <div
    class="flex flex-wrap sm:flex-nowrap bg-slate-100 dark:bg-slate-900 p-1.5 rounded-2xl border border-slate-200 dark:border-slate-800 gap-1 sm:space-x-2">
    <button (click)="setTab('stadium')" id="club-tab-stadium"
      class="flex-1 flex items-center justify-center space-x-2 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all cursor-pointer"
      [ngClass]="activeTab === 'stadium' ? 'bg-white dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 shadow-sm border border-slate-200/80 dark:border-slate-700' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'">
      <app-icon name="building" [size]="16" />
      <span>{{ game.t('stadium.tab_stadium') }}</span>
    </button>

    <button (click)="setTab('staff')" id="club-tab-staff"
      class="flex-1 flex items-center justify-center space-x-2 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all cursor-pointer"
      [ngClass]="activeTab === 'staff' ? 'bg-white dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 shadow-sm border border-slate-200/80 dark:border-slate-700' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'">
      <app-icon name="award" [size]="16" />
      <span>{{ game.t('stadium.tab_staff') }}</span>
    </button>

    <button (click)="setTab('sponsors')" id="club-tab-sponsors"
      class="flex-1 flex items-center justify-center space-x-2 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all cursor-pointer"
      [ngClass]="activeTab === 'sponsors' ? 'bg-white dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 shadow-sm border border-slate-200/80 dark:border-slate-700' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'">
      <app-icon name="badge-dollar-sign" [size]="16" />
      <span>{{ game.t('stadium.tab_sponsors') }}</span>
    </button>

    <button (click)="setTab('economy')" id="club-tab-economy"
      class="flex-1 flex items-center justify-center space-x-2 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all cursor-pointer"
      [ngClass]="activeTab === 'economy' ? 'bg-white dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 shadow-sm border border-slate-200/80 dark:border-slate-700' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'">
      <app-icon name="coins" [size]="16" />
      <span>{{ game.t('stadium.tab_economy') }}</span>
    </button>
    
  </div>

  <!-- TAB 1: ESTADIO -->
  @if (activeTab === 'stadium') {
  <div class="space-y-6">
    <app-stadium-name class="block" />
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div
        class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-4 shadow-xs transition-colors">
        <div class="flex items-center justify-between">
          <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('stadium.pricing_title') }}</h3>
          @if (game.ticketPriceData(); as tp) {
          <span
            class="px-2 py-0.5 text-[10px] rounded-md font-mono bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 border border-slate-200 dark:border-slate-700"
            title="Versión del precio de entradas">
            v{{ tp.version }}
          </span>
          }
        </div>
        <p class="text-xs text-slate-500 dark:text-slate-400">
          {{ game.t('stadium.pricing_desc') }}
        </p>

        <div class="space-y-3 pt-2">
          <div class="flex items-center justify-between gap-3">
            <label for="ticket-price-input" class="text-xs font-semibold text-slate-700 dark:text-slate-300">
              {{ game.t('stadium.general_ticket_price') }}
            </label>
            <div class="flex items-center space-x-1.5">
              <input id="ticket-price-input" type="text" inputmode="decimal" appMoneyInput min="10" max="150" step="0.01" [(ngModel)]="ticketPriceInput"
                class="w-24 px-2.5 py-1 text-right text-base font-bold font-mono text-emerald-700 dark:text-emerald-400 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-lg focus:outline-none focus:ring-1 focus:ring-emerald-500" />
              <span class="text-sm font-bold text-slate-600 dark:text-slate-400">€</span>
            </div>
          </div>
          <input type="range" min="10" max="150" step="1" [(ngModel)]="ticketPriceInput"
            class="w-full accent-emerald-600 cursor-pointer" />
          <div class="flex justify-between text-[10px] text-slate-500 dark:text-slate-400 font-mono">
            <span>10 € (Económico)</span>
            <span>115 € (Referencia)</span>
            <span>150 € (Máximo)</span>
          </div>
        </div>

        <div class="pt-4 flex items-center justify-between border-t border-slate-100 dark:border-slate-800">
          <button type="button" (click)="applyTicketPrice()" [disabled]="!game.canAction('changeTicketPrice') || (isUpdatingTicketPrice())"
            class="px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white font-semibold text-xs rounded-xl shadow-xs transition-all cursor-pointer active:scale-98 disabled:opacity-50 flex items-center space-x-2">
            @if (isUpdatingTicketPrice()) {
            <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <span>Guardando...</span>
            } @else {
            <app-icon name="check" [size]="14" />
            <span>{{ game.t('stadium.confirm_pricing') }}</span>
            }
          </button>
        </div>
      </div>

      <!-- Attendance Simulator Preview -->
      <div
        class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-4 shadow-xs transition-colors">
        <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('stadium.attendance_sim_title') }}</h3>
        <p class="text-xs text-slate-500 dark:text-slate-400">{{ game.t('stadium.attendance_sim_note') }}</p>
        <div class="space-y-3 text-xs">
          <div
            class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">{{ game.t('stadium.total_capacity') }}:</span>
            <span class="font-bold text-slate-900 dark:text-white font-mono">{{
              effectiveCapacity.toLocaleString() }}</span>
          </div>
          <div
            class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">{{ game.t('stadium.est_attendance') }}:</span>
            <span class="font-bold text-emerald-700 dark:text-emerald-400 font-mono">{{
              attendanceSim().attendance.toLocaleString() }} ({{ attendanceSim().percentage.toFixed(1) }}%)</span>
          </div>
          <div
            class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">{{ game.t('stadium.projected_tickets') }}:</span>
            <span class="font-bold text-emerald-700 dark:text-emerald-400 font-mono">{{ (attendanceSim().ticketRevenueM).toFixed(3) }} M€</span>
          </div>
          <div
            class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">{{ game.t('stadium.projected_commercial') }}:</span>
            <span class="font-bold text-emerald-700 dark:text-emerald-400 font-mono">{{ (attendanceSim().commercialRevenueM).toFixed(3) }} M€</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 1. OBRA ACTIVA DE REMODELACIÓN (visible solo si hay obra en curso) -->
    @if (activeConstructionOp; as op) {
    <div
      class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-4 shadow-xs transition-colors">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h3 class="text-base font-bold text-slate-900 dark:text-white flex items-center gap-2">
            <app-icon name="hammer" [size]="18" class="text-amber-500" />
            <span>{{ game.t('stadium.construction_active_title') }}</span>
          </h3>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            Estado de obras, planificación temporal y liquidación económica
          </p>
        </div>

        <div class="flex items-center gap-2">
          <span class="px-2.5 py-1 rounded-lg text-xs font-semibold border"
            [ngClass]="getOperationStatusBadgeClass(op.status)">
            {{ getOperationStatusLabel(op.status) }}
          </span>
        </div>
      </div>

      <div
        class="p-4 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 space-y-3 text-xs">
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
          <div>
            <div class="text-[10px] uppercase font-bold text-slate-400">Módulo</div>
            <div class="font-bold text-slate-900 dark:text-white mt-0.5 font-mono">
              {{ getModuleTitle(op.module) }}
            </div>
          </div>
          <div>
            <div class="text-[10px] uppercase font-bold text-slate-400">Coste Presupuestado</div>
            <div class="font-bold text-emerald-700 dark:text-emerald-400 mt-0.5 font-mono">
              {{ ((op.quotedCost / 1_000_000)).toFixed(2) }} M€
            </div>
          </div>
          <div>
            <div class="text-[10px] uppercase font-bold text-slate-400">Nivel / Capacidad</div>
            <div class="font-semibold text-slate-700 dark:text-slate-300 mt-0.5">
              @if (op.module === 'STANDS') {
              Aforo previsto: {{ game.constructionData()?.schedule?.targetCapacity?.toLocaleString() || 'Calculando...'
              }}
              } @else {
              Nivel {{ op.fromLevel ?? 1 }} → Nivel {{ op.toLevel ?? 2 }}
              }
            </div>
          </div>
          <div>
            <div class="text-[10px] uppercase font-bold text-slate-400">Planificación</div>
            <div class="font-semibold text-slate-700 dark:text-slate-300 mt-0.5">
              @if (game.constructionData()?.completionMatchdayNumber) {
              Finalización prevista: al cierre de la jornada {{ game.constructionData()?.completionMatchdayNumber }}
              } @else {
              Planificación no disponible
              }
            </div>
          </div>
        </div>

        <!-- Barra de progreso de jornadas si hay calendario -->
        @if (game.constructionData()?.schedule; as sch) {
        <div class="pt-2 border-t border-slate-200 dark:border-slate-800">
          <div class="flex justify-between items-center text-[11px] text-slate-500 dark:text-slate-400 mb-1">
            <span>Jornada inicial: J{{ sch.startMatchdayNumber }}</span>
            <span>
              Jornadas cerradas: {{ sch.closedMatchdays }} / {{ sch.durationMatchdays }}
              @if (game.constructionData()?.remainingMatchdays !== null) {
              (Restantes: {{ game.constructionData()?.remainingMatchdays }})
              }
            </span>
          </div>
          <div class="w-full bg-slate-200 dark:bg-slate-800 rounded-full h-2 overflow-hidden">
            <div class="bg-amber-500 h-2 rounded-full transition-all duration-500"
              [style.width.%]="sch.durationMatchdays > 0 ? (sch.closedMatchdays / sch.durationMatchdays) * 100 : 0">
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }

    <!-- 2. AMPLIACIÓN DE GRADAS Y AFORO (CATÁLOGO DINÁMICO) -->
    <div
      class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-4 shadow-xs transition-colors">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div>
          <h3 class="text-base font-bold text-slate-900 dark:text-white">
            {{ game.t('stadium.capacity_upgrade_title') }}
          </h3>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            Aforo actual: <span class="font-bold font-mono text-slate-900 dark:text-white">{{
              effectiveCapacity.toLocaleString() }}</span> espectadores
            (Aforo máximo: <span class="font-bold font-mono">{{ maximumCapacity.toLocaleString() }}</span>)
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
        @for (pack of standsUpgradePacks; track pack.code) {
        @let disabled = isStandsPackDisabled(pack) || !!activeConstructionOp;
        <div class="p-4 rounded-xl border text-xs flex flex-col justify-between space-y-3 transition-colors"
          [ngClass]="disabled ? 'bg-slate-50/50 dark:bg-slate-950/40 border-slate-200/60 dark:border-slate-800/60 opacity-80' : 'bg-slate-50 dark:bg-slate-950 border-slate-200 dark:border-slate-800'">
          <div>
            <div class="text-sm font-bold text-slate-900 dark:text-white font-mono">
              +{{ (pack.capacityIncrease || 0).toLocaleString() }}
            </div>
            <div class="text-[10px] text-slate-500 dark:text-slate-400 mt-0.5">
              Resultante: {{ (effectiveCapacity + (pack.capacityIncrease || 0)).toLocaleString() }} {{
              game.t('stadium.seats') }}
            </div>
            <div class="text-xs font-mono font-bold text-emerald-700 dark:text-emerald-400 mt-2">
              {{ ((pack.cost / 1_000_000)).toFixed(2) }} M€
            </div>
            <div class="text-[10px] text-slate-400 mt-0.5">
              Duración: {{ pack.durationMatchdays }} {{ pack.durationMatchdays === 1 ? 'jornada' : 'jornadas' }}
            </div>
          </div>

          @if (isStandsPackDisabled(pack)) {
          <div
            class="py-1.5 text-center text-[10px] font-semibold text-slate-400 dark:text-slate-600 bg-slate-100 dark:bg-slate-900 rounded-lg">
            Supera aforo máximo
          </div>
          } @else if (activeConstructionOp) {
          <div
            class="py-1.5 text-center text-[10px] font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/40 rounded-lg">
            Obra en curso
          </div>
          } @else {
          <button type="button" (click)="requestQuote('STANDS', pack.code)" [disabled]="isQuoting()"
            class="w-full py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-lg text-xs transition-colors cursor-pointer active:scale-98 shadow-xs disabled:opacity-50">
            Presupuestar (+{{ (pack.capacityIncrease || 0) / 1000 }}k)
          </button>
          }
        </div>
        }
      </div>
    </div>

    <!-- 3. INSTALACIONES Y MÓDULOS COMERCIALES (PARKING, CAFETERIA, MERCHANDISING, BATHROOMS) -->
    <div
      class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-4 shadow-xs transition-colors">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div>
          <h3 class="text-base font-bold text-slate-900 dark:text-white">
            {{ game.t('stadium.commercial_modules_title') }}
          </h3>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            Instalaciones comerciales e higiene
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        @for (mod of facilityModules; track mod) {
        @let curLvl = getModuleCurrentLevel(mod);
        @let nextOpt = getFacilityNextUpgrade(mod);
        @let hasActiveOp = !!activeConstructionOp;

        <div
          class="p-4 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl space-y-3 flex flex-col justify-between">
          <div class="space-y-2">
            <div class="flex items-center justify-between">
              <h4 class="text-sm font-bold text-slate-900 dark:text-white">
                {{ getModuleTitle(mod) }}
              </h4>
              <span
                class="text-xs bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 px-2 py-0.5 rounded font-mono border border-slate-200 dark:border-slate-700">
                Nivel {{ curLvl }}/5
              </span>
            </div>
            <p class="text-xs text-slate-500 dark:text-slate-400">
              {{ getModuleDescription(mod) }}
            </p>
          </div>

          <div class="pt-2 border-t border-slate-200/80 dark:border-slate-800">
            @if (curLvl >= 5) {
            <div class="text-xs text-emerald-700 dark:text-emerald-400 font-bold text-center py-2">
              {{ game.t('stadium.max_level') }} (Nivel 5)
            </div>
            } @else if (nextOpt) {
            <div class="space-y-2">
              <div class="flex justify-between items-center text-[11px] text-slate-500 dark:text-slate-400 font-mono">
                <span>Siguiente: Nivel {{ nextOpt.targetLevel }}</span>
                <span class="font-bold text-emerald-700 dark:text-emerald-400">
                  {{ ((nextOpt.cost / 1_000_000)).toFixed(2) }} M€
                </span>
              </div>

              @if (hasActiveOp) {
              <div
                class="py-1.5 text-center text-[10px] font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/40 rounded-lg">
                Obra en curso
              </div>
              } @else {
              <button type="button" (click)="requestQuote(mod)" [disabled]="isQuoting()"
                class="w-full py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-800 dark:text-slate-200 text-xs font-semibold rounded-lg transition-colors cursor-pointer disabled:opacity-50">
                Presupuestar Nivel {{ nextOpt.targetLevel }}
              </button>
              }
            </div>
            } @else {
            <div class="text-xs text-slate-400 text-center py-2">
              Sin opciones en catálogo
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
  }

  <!-- TAB 2: STAFF -->
  @if (activeTab === 'staff') {
    <app-staff-panel [clubId]="game.userClub().id" />
  }

  <!-- TAB 3: SPONSORS (PATROCINIOS DEL CLUB) -->
  @if (activeTab === 'sponsors') {
  <div class="space-y-6">
    <!-- BLOQUE 1: MIS SPONSORS (CONTRATOS ACTIVOS Y PENDIENTES DE ACTIVACIÓN) -->
    <div
      class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-4 shadow-xs transition-colors">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 border-b border-slate-100 dark:border-slate-800 pb-3">
        <div>
          <h4 class="text-sm font-bold text-slate-900 dark:text-white flex items-center gap-2">
            <app-icon name="briefcase" [size]="16" class="text-blue-600 dark:text-blue-400" />
            <span>{{ game.t('sponsors.my_sponsors_title') }}</span>
          </h4>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            {{ game.t('sponsors.my_sponsors_desc') }}
          </p>
        </div>
        <span class="text-xs font-mono font-semibold text-slate-500 dark:text-slate-400">
          {{ game.activeSponsorContracts().length }} contratado(s)
        </span>
      </div>

      <!-- Error al consultar contratos -->
      @if (game.sponsorContractsError(); as contractErr) {
      <div
        class="p-4 bg-rose-50 dark:bg-rose-950/60 border border-rose-200 dark:border-rose-800 rounded-xl text-rose-700 dark:text-rose-300 text-xs flex items-center justify-between gap-3">
        <div class="flex items-center gap-2">
          <app-icon name="alert-triangle" [size]="16" class="shrink-0" />
          <span>{{ contractErr }}</span>
        </div>
        <button type="button" (click)="game.fetchSponsorContracts(game.userClub().id, true)"
          class="px-3 py-1.5 bg-rose-600 hover:bg-rose-700 text-white rounded-lg font-semibold transition-colors cursor-pointer shrink-0">
          Reintentar
        </button>
      </div>
      }

      <!-- Estado de carga de contratos -->
      @if (game.isSponsorContractsLoading() && game.activeSponsorContracts().length === 0) {
      <div class="py-12 flex flex-col items-center justify-center space-y-3 text-slate-400">
        <app-icon name="rotate-ccw" [size]="28" class="animate-spin text-emerald-600" />
        <span class="text-xs font-medium">Consultando contratos de patrocinio...</span>
      </div>
      } @else if (game.activeSponsorContracts().length === 0) {
      <!-- Estado vacío informativo -->
      <div
        class="p-8 text-center bg-slate-50 dark:bg-slate-950/50 rounded-xl border border-dashed border-slate-200 dark:border-slate-800 space-y-2">
        <div class="w-12 h-12 mx-auto rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400">
          <app-icon name="briefcase" [size]="22" />
        </div>
        <h5 class="text-sm font-bold text-slate-800 dark:text-slate-200">
          {{ game.t('sponsors.empty_contracts') }}
        </h5>
        <p class="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto">
          {{ game.t('sponsors.empty_contracts_sub') }}
        </p>
      </div>
      } @else {
      <!-- Listado de contratos vigentes -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        @for (contract of game.activeSponsorContracts(); track contract.id) {
        <div
          class="bg-slate-50 dark:bg-slate-950 p-4 rounded-xl border border-slate-200 dark:border-slate-800 flex flex-col justify-between space-y-3">
          <div>
            <div class="flex items-start justify-between gap-2">
              <div class="flex items-center space-x-3">
                @if (contract.logoUrl) {
                <img [src]="contract.logoUrl" [alt]="contract.sponsorName"
                  class="w-10 h-10 rounded-lg object-contain bg-white dark:bg-slate-900 p-1 border border-slate-200 dark:border-slate-800"
                  referrerpolicy="no-referrer" />
                } @else {
                <div
                  class="w-10 h-10 rounded-lg bg-emerald-100 dark:bg-emerald-950/60 border border-emerald-200 dark:border-emerald-800 flex items-center justify-center text-emerald-700 dark:text-emerald-300">
                  <app-icon [name]="getSponsorTypeIcon(contract.type)" [size]="20" />
                </div>
                }
                <div>
                  <h5 class="text-sm font-bold text-slate-900 dark:text-white leading-tight">
                    {{ contract.sponsorName }}
                  </h5>
                  <span class="inline-block mt-0.5 px-2 py-0.5 rounded-md text-[10px] font-bold border"
                    [ngClass]="getSponsorTypeBadgeClass(contract.type)">
                    {{ getSponsorTypeLabel(contract.type) }}
                  </span>
                </div>
              </div>

              <span class="px-2 py-0.5 rounded-md text-[10px] font-bold"
                [ngClass]="getSponsorContractStatusBadge(contract.status).class">
                {{ getSponsorContractStatusBadge(contract.status).label }}
              </span>
            </div>

            <!-- Si está pendiente de activación -->
            @if (contract.status === 'PENDING_ACTIVATION') {
            <div class="mt-2.5 p-2 bg-amber-50 dark:bg-amber-950/60 border border-amber-200 dark:border-amber-800 rounded-lg text-amber-800 dark:text-amber-300 text-[11px] flex items-center gap-1.5">
              <app-icon name="clock" [size]="14" class="shrink-0" />
              <span>Pendiente de activación para la próxima jornada. El cobro se liquidará tras activarse.</span>
            </div>
            }

            <!-- Métricas económicas del contrato -->
            <div class="grid grid-cols-2 gap-2 mt-3 pt-3 border-t border-slate-200 dark:border-slate-800/80 text-xs">
              <div>
                <span class="text-[10px] text-slate-500 dark:text-slate-400 block uppercase font-bold">Fijo Contratado</span>
                <span class="font-bold font-mono text-emerald-700 dark:text-emerald-400">
                  {{ formatAmount(getContractFixedAmount(contract)) }}
                </span>
              </div>
              <div>
                <span class="text-[10px] text-slate-500 dark:text-slate-400 block uppercase font-bold">Bonus Victoria</span>
                <span class="font-bold font-mono text-slate-700 dark:text-slate-300">
                  {{ getContractWinBonusAmount(contract) !== null ? formatAmount(getContractWinBonusAmount(contract)) : '—' }}
                </span>
              </div>
              <div>
                <span class="text-[10px] text-slate-500 dark:text-slate-400 block uppercase font-bold">Vigencia</span>
                <span class="font-semibold text-slate-700 dark:text-slate-300">
                  Jornadas {{ contract.startMatchdayNumber }} - {{ contract.endMatchdayNumber }}
                </span>
              </div>
              <div>
                <span class="text-[10px] text-slate-500 dark:text-slate-400 block uppercase font-bold">Restantes</span>
                <span class="font-semibold text-slate-700 dark:text-slate-300">
                  {{ contract.remainingMatchdays }} jornada(s)
                </span>
              </div>
            </div>
          </div>

          <div class="pt-2 border-t border-slate-200 dark:border-slate-800 flex items-center justify-between text-xs">
            <span class="text-[11px] text-slate-500 dark:text-slate-400">Ingresos acumulados:</span>
            <span class="font-bold font-mono text-slate-900 dark:text-white">
              {{ formatAmount(contract.accumulatedRevenue) }}
            </span>
          </div>
        </div>
        }
      </div>
      }
    </div>

    <!-- BLOQUE 2: OFERTAS DE LA JORNADA -->
    <div
      class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-6 shadow-xs transition-colors">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 border-b border-slate-100 dark:border-slate-800 pb-3">
        <div>
          <h4 class="text-sm font-bold text-slate-900 dark:text-white flex items-center gap-2">
            <app-icon name="store" [size]="16" class="text-emerald-600 dark:text-emerald-400" />
            <span>{{ game.t('sponsors.market_title') }}</span>
          </h4>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            {{ game.t('sponsors.market_desc') }}
          </p>
        </div>
      </div>

      <!-- Error HTTP 503: Mercado no disponible temporalmente -->
      @if (game.sponsorOffersStatus() === 503) {
      <div
        class="p-4 bg-amber-50 dark:bg-amber-950/60 border border-amber-200 dark:border-amber-800 rounded-xl text-amber-800 dark:text-amber-300 text-xs flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div class="flex items-center gap-2">
          <app-icon name="alert-triangle" [size]="18" class="shrink-0 text-amber-600 dark:text-amber-400" />
          <span>{{ game.t('sponsors.market_503') }}</span>
        </div>
        <button type="button" (click)="game.fetchSponsorOffers(game.userClub().id, true)"
          class="px-3.5 py-1.5 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-semibold transition-colors cursor-pointer shrink-0 flex items-center gap-1.5">
          <app-icon name="rotate-ccw" [size]="14" />
          <span>{{ game.t('sponsors.retry_market') }}</span>
        </button>
      </div>
      } @else if (game.sponsorOffersError(); as offersErr) {
      <!-- Otro error general -->
      <div
        class="p-4 bg-rose-50 dark:bg-rose-950/60 border border-rose-200 dark:border-rose-800 rounded-xl text-rose-700 dark:text-rose-300 text-xs flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div class="flex items-center gap-2">
          <app-icon name="alert-circle" [size]="18" class="shrink-0" />
          <span>{{ offersErr }}</span>
        </div>
        <button type="button" (click)="game.fetchSponsorOffers(game.userClub().id, true)"
          class="px-3.5 py-1.5 bg-rose-600 hover:bg-rose-700 text-white rounded-lg font-semibold transition-colors cursor-pointer shrink-0">
          {{ game.t('sponsors.retry_market') }}
        </button>
      </div>
      }

      <!-- Estado de carga de ofertas -->
      @if (game.isSponsorOffersLoading() && game.sponsorOffers().length === 0) {
      <div class="py-12 flex flex-col items-center justify-center space-y-3 text-slate-400">
        <app-icon name="rotate-ccw" [size]="28" class="animate-spin text-emerald-600" />
        <span class="text-xs font-medium">Consultando ofertas de patrocinio del mercado...</span>
      </div>
      } @else if (game.sponsorOffers().length === 0 && !game.sponsorOffersError() && game.sponsorOffersStatus() !== 503) {
      <!-- Respuesta vacía []: no hay jornada disponible -->
      <div
        class="p-8 text-center bg-slate-50 dark:bg-slate-950/50 rounded-xl border border-dashed border-slate-200 dark:border-slate-800 space-y-2">
        <div class="w-12 h-12 mx-auto rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400">
          <app-icon name="calendar" [size]="22" />
        </div>
        <h5 class="text-sm font-bold text-slate-800 dark:text-slate-200">
          {{ game.t('sponsors.empty_market') }}
        </h5>
        <p class="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto">
          No hay una jornada disponible para contratar patrocinios en este momento. Las ofertas se actualizarán con el avance de la competición.
        </p>
      </div>
      } @else {
      <!-- Ofertas agrupadas por Tipo (BILLBOARD, SHIRT, STADIUM) -->
      <div class="space-y-8">
        @for (type of sponsorTypes; track type) {
        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-2">
              <span class="p-1.5 rounded-lg border" [ngClass]="getSponsorTypeBadgeClass(type)">
                <app-icon [name]="getSponsorTypeIcon(type)" [size]="16" />
              </span>
              <h5 class="text-sm font-bold text-slate-900 dark:text-white">
                {{ getSponsorTypeLabel(type) }}
              </h5>
            </div>

            @if (isSponsorTypeOccupied(type)) {
            <span class="px-2.5 py-0.5 rounded-full text-[10px] font-bold bg-amber-50 text-amber-700 border border-amber-200 dark:bg-amber-950 dark:text-amber-400 dark:border-amber-800">
              Contrato en vigor
            </span>
            } @else {
            <span class="px-2.5 py-0.5 rounded-full text-[10px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-950 dark:text-emerald-400 dark:border-emerald-800">
              Disponible
            </span>
            }
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            @for (offer of getOffersForType(type); track offer.id) {
            <div
              class="bg-slate-50 dark:bg-slate-950 p-4 rounded-xl border border-slate-200 dark:border-slate-800 flex flex-col justify-between space-y-4 hover:border-slate-300 dark:hover:border-slate-700 transition-colors">
              <div>
                <div class="flex items-start justify-between gap-2">
                  <div class="flex items-center space-x-3">
                    @if (offer.logoUrl) {
                    <img [src]="offer.logoUrl" [alt]="offer.sponsorName"
                      class="w-10 h-10 rounded-lg object-contain bg-white dark:bg-slate-900 p-1 border border-slate-200 dark:border-slate-800"
                      referrerpolicy="no-referrer" />
                    } @else {
                    <div
                      class="w-10 h-10 rounded-lg bg-slate-200 dark:bg-slate-800 flex items-center justify-center text-slate-600 dark:text-slate-300">
                      <app-icon [name]="getSponsorTypeIcon(offer.type)" [size]="20" />
                    </div>
                    }
                    <div>
                      <h6 class="text-sm font-bold text-slate-900 dark:text-white leading-tight">
                        {{ offer.sponsorName }}
                      </h6>
                      <span class="text-[11px] text-slate-500 dark:text-slate-400">
                        Duración: <strong>{{ getOfferDuration(offer) }} jornadas</strong>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Condiciones económicas -->
                <div class="mt-4 p-3 bg-white dark:bg-slate-900/90 rounded-xl border border-slate-200/80 dark:border-slate-800 space-y-2 text-xs">
                  <div class="flex justify-between items-center">
                    <span class="text-[11px] text-slate-500 dark:text-slate-400">Ingreso inicial del contrato:</span>
                    <span class="font-bold font-mono text-emerald-700 dark:text-emerald-400 text-sm">
                      {{ formatAmount(getOfferFixedAmount(offer)) }}
                    </span>
                  </div>
                  <div class="flex justify-between items-center pt-1 border-t border-slate-100 dark:border-slate-800">
                    <span class="text-[11px] text-slate-500 dark:text-slate-400">Bonus por victoria:</span>
                    <span class="font-semibold font-mono text-slate-700 dark:text-slate-300">
                      {{ getOfferWinBonusAmount(offer) !== null ? formatAmount(getOfferWinBonusAmount(offer)) : 'Sin bonus' }}
                    </span>
                  </div>
                </div>

                @if (getOfferDisabledReason(offer); as disabledReason) {
                <div class="mt-2 text-[11px] text-amber-700 dark:text-amber-400 flex items-center gap-1 font-medium">
                  <app-icon name="lock" [size]="12" class="shrink-0" />
                  <span>{{ game.t('sponsors.disabled_reasons.' + disabledReason) }}</span>
                </div>
                }
              </div>

              <!-- Botón Contratar -->
              <button type="button" [id]="'btn-contract-sponsor-' + offer.id"
                (click)="openSponsorModal(offer)"
                [disabled]="!game.canAction('signSponsor') || (!!getOfferDisabledReason(offer))"
                class="w-full py-2.5 px-4 rounded-xl text-xs font-semibold transition-all cursor-pointer flex items-center justify-center space-x-1.5 shadow-xs disabled:opacity-50 disabled:cursor-not-allowed"
                [ngClass]="getOfferDisabledReason(offer)
                  ? 'bg-slate-200 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border border-slate-300/50 dark:border-slate-700'
                  : 'bg-emerald-600 hover:bg-emerald-700 text-white active:scale-98'">
                <app-icon name="check-circle" [size]="14" />
                <span>{{ game.t('sponsors.btn_contract') }}</span>
              </button>
            </div>
            } @empty {
            <div class="col-span-full p-4 text-center text-xs text-slate-400 bg-slate-50 dark:bg-slate-950/40 rounded-xl border border-dashed border-slate-200 dark:border-slate-800">
              No hay ofertas publicadas para esta categoría en la jornada actual.
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
  }

  <!-- TAB 4: ECONOMÍA (Finanzas, Créditos CR, Préstamos y Ledger) -->
  @if (activeTab === 'economy') {
  <div class="grid min-w-0 grid-cols-1 gap-6">
    <!-- Matchday Loans (Créditos por Jornada Oficiales) -->
    <details class="group/credits rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950/40">
      <summary class="flex items-center justify-between gap-3 p-3 cursor-pointer list-none [&::-webkit-details-marker]:hidden text-sm font-semibold text-slate-700 dark:text-slate-200">
        <span class="flex items-center gap-2">
          <app-icon name="dollar-sign" [size]="16" class="text-slate-400" />
          <span>Crédito bancario</span>
        </span>
        <span class="flex shrink-0 items-center gap-2">
          @if (game.aggregatedDebt() || game.activeMatchdayLoan()) {
            <span class="text-xs font-mono font-bold text-amber-700 dark:text-amber-400 whitespace-nowrap" title="Deuda total">
              <span class="sr-only">Deuda total: </span>
              {{ (game.aggregatedDebt()?.totalDebt ?? game.activeMatchdayLoan()?.outstandingPrincipal ?? 0) | number:'1.2-2' }} €
            </span>
          }
          <app-icon name="chevron-down" [size]="16" class="transition-transform group-open/credits:rotate-180" />
        </span>
      </summary>
      <div class="p-2 sm:p-3 pt-0">
        <app-matchday-loans />
      </div>
    </details>

    <!-- Accounting Ledger Table inside Economy tab -->
    <div
      class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-3 space-y-4 shadow-xs transition-colors">
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div>
          <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('club.ledger_title') }}</h3>          
        </div>
        <span class="text-xs text-slate-500 dark:text-slate-400 font-mono">
          {{ ledgerList.length }} {{ game.t('club.ledger_entries') }}
        </span>
      </div>

      <!-- Tarjeta de Evolución de Tesorería 
      @if (ledgerList.length > 0) {
      <div
        class="grid grid-cols-2 sm:grid-cols-4 gap-3 p-3.5 bg-slate-50 dark:bg-slate-950/70 border border-slate-200 dark:border-slate-800/80 rounded-xl text-xs">
        <div>
          <div class="text-slate-500 dark:text-slate-400 text-[11px]">Presupuesto Inicial</div>
          <div class="font-bold text-slate-900 dark:text-white font-mono text-sm mt-0.5">
            {{ (ledgerSummary.initialBudget).toFixed(2) }} M€
          </div>
        </div>
        <div>
          <div class="text-slate-500 dark:text-slate-400 text-[11px]">Ingresos Acumulados</div>
          <div class="font-bold text-emerald-600 dark:text-emerald-400 font-mono text-sm mt-0.5">
            +{{ (ledgerSummary.totalIncome).toFixed(2) }} M€
          </div>
        </div>
        <div>
          <div class="text-slate-500 dark:text-slate-400 text-[11px]">Gastos e Inversión</div>
          <div class="font-bold text-rose-600 dark:text-rose-400 font-mono text-sm mt-0.5">
            -{{ (ledgerSummary.totalExpenses).toFixed(2) }} M€
          </div>
        </div>
        <div>
          <div class="text-slate-500 dark:text-slate-400 text-[11px]">Saldo Resultante Actual</div>
          <div class="font-bold text-slate-900 dark:text-white font-mono text-sm mt-0.5">
            {{ (ledgerSummary.currentBalance).toFixed(2) }} M€
          </div>
        </div>
      </div>
      }-->

      <div class="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-800">
        <table class="w-full text-left text-xs">
          <thead
            class="bg-slate-50 dark:bg-slate-950 text-slate-600 dark:text-slate-400 font-bold uppercase text-[10px] border-b border-slate-200 dark:border-slate-800">
            <tr>
              <th class="py-2.5 px-2.5 sm:px-3">{{ game.t('club.ledger_col_date') }}</th>
              <th class="py-2.5 px-2.5 sm:px-3">{{ game.t('club.ledger_col_concept') }}</th>
              <th class="py-2.5 px-3 text-center hidden md:table-cell">{{ game.t('club.ledger_col_origin') }}</th>
              <th class="py-2.5 px-2.5 sm:px-3 text-right">{{ game.t('club.ledger_col_amount') }}</th>
              <th class="py-2.5 px-2.5 sm:px-3 text-right">{{ game.t('club.ledger_col_balance') }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-100 dark:divide-slate-800/60 font-medium">
            @for (entry of ledgerList; track entry.id || $index) {
            <tr class="hover:bg-slate-50 dark:hover:bg-slate-800/40 transition-colors">
              <!-- Fecha con la hora debajo -->
              <td class="py-2.5 px-2.5 sm:px-3 font-mono whitespace-nowrap">
                <div class="text-[11px] font-semibold text-slate-700 dark:text-slate-300">
                  {{ entry.timestamp | date:'dd/MM' }}<span class="ledger-date-year">{{ entry.timestamp | date:'/yy' }}</span>
                </div>
                <div class="text-[10px] text-slate-400 dark:text-slate-500">
                  {{ entry.timestamp | date:'HH:mm' }}
                </div>
              </td>

              <!-- Concepto -->
              <td class="py-2.5 px-2.5 sm:px-3 text-slate-900 dark:text-white">
                <div class="font-bold text-slate-900 dark:text-white text-xs">
                  {{ getConceptLabel(entry.concept, entry.category, entry.direction) }}
                </div>
              </td>

              <!-- Origen (oculto en móvil portrait) -->
              <td
                class="py-2.5 px-3 text-center whitespace-nowrap text-slate-600 dark:text-slate-400 text-[11px] hidden md:table-cell">
                <span
                  class="px-2 py-0.5 rounded-md bg-slate-100 dark:bg-slate-800 font-medium border border-slate-200 dark:border-slate-700/60">
                  {{ getSourceTypeLabel(entry.sourceType) }}
                </span>
              </td>

              <!-- Importe -->
              <td class="py-2.5 px-2.5 sm:px-3 text-right font-mono font-bold whitespace-nowrap text-xs"
                [ngClass]="(entry.direction === 'CREDIT' || entry.type === 'INGRESO') ? 'text-emerald-700 dark:text-emerald-400' : 'text-rose-600 dark:text-rose-400'">
                {{ (entry.direction === 'CREDIT' || entry.type === 'INGRESO') ? '+' : '-' }}{{ (entry.amount).toFixed(2) }} M€
              </td>

              <!-- Saldo resultante informado por el backend -->
              <td
                class="py-2.5 px-2.5 sm:px-3 text-right font-mono font-bold text-slate-700 dark:text-slate-200 whitespace-nowrap text-xs">
                {{ entry.runningBalance != null ? entry.runningBalance.toFixed(2) + ' M€' : '—' }}
              </td>
            </tr>
            } @empty {
            <tr>
              <td colspan="5" class="py-8 text-center text-slate-500 dark:text-slate-400">
                {{ game.t('club.no_ledger_entries') }}
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      @if (hasMoreLedger()) {
        <div class="flex justify-center pt-2">
          <button
            type="button"
            (click)="loadMoreLedger()"
            [disabled]="isLoadingMoreLedger()"
            class="px-4 py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-xl text-xs font-semibold transition-colors cursor-pointer disabled:opacity-50 flex items-center gap-1.5"
          >
            @if (isLoadingMoreLedger()) {
              <app-icon name="refresh-cw" [size]="14" class="animate-spin" />
              <span>Cargando más movimientos...</span>
            } @else {
              <span>Cargar movimientos anteriores (página {{ ledgerPage() + 1 }})</span>
            }
          </button>
        </div>
      }
    </div>
  </div>
  }

  <!-- MODAL DE CONFIRMACIÓN DE CONTRATACIÓN DE SPONSOR -->
  @if (selectedOfferForContract(); as offer) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs transition-opacity"
    role="dialog" aria-modal="true">
    <div
      class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl max-w-lg w-full p-6 shadow-2xl space-y-5 text-slate-900 dark:text-white">
      <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
        <div class="flex items-center gap-2">
          <app-icon name="briefcase" [size]="20" class="text-emerald-600 dark:text-emerald-400" />
          <h3 class="text-base font-bold">{{ game.t('sponsors.modal_title') }}</h3>
        </div>
        <button type="button" (click)="closeSponsorModal()" [disabled]="isSubmittingSponsorContract()"
          class="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer disabled:opacity-50">
          <app-icon name="x" [size]="18" />
        </button>
      </div>

      <div class="space-y-3 text-xs">
        <div class="flex items-center space-x-3 p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800">
          @if (offer.logoUrl) {
          <img [src]="offer.logoUrl" [alt]="offer.sponsorName"
            class="w-12 h-12 rounded-lg object-contain bg-white dark:bg-slate-900 p-1 border border-slate-200 dark:border-slate-800"
            referrerpolicy="no-referrer" />
          } @else {
          <div
            class="w-12 h-12 rounded-lg bg-emerald-100 dark:bg-emerald-950/60 border border-emerald-200 dark:border-emerald-800 flex items-center justify-center text-emerald-700 dark:text-emerald-300">
            <app-icon [name]="getSponsorTypeIcon(offer.type)" [size]="24" />
          </div>
          }
          <div>
            <h4 class="text-base font-bold text-slate-900 dark:text-white">
              {{ offer.sponsorName }}
            </h4>
            <span class="inline-block mt-0.5 px-2 py-0.5 rounded-md text-[10px] font-bold border"
              [ngClass]="getSponsorTypeBadgeClass(offer.type)">
              {{ getSponsorTypeLabel(offer.type) }}
            </span>
          </div>
        </div>

        <div
          class="p-4 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2.5">
          <div class="flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">Tipo de patrocinio:</span>
            <span class="font-bold">{{ getSponsorTypeLabel(offer.type) }}</span>
          </div>
          <div class="flex justify-between items-center pt-1 border-t border-slate-200 dark:border-slate-800">
            <span class="text-slate-500 dark:text-slate-400">Duración efectiva:</span>
            <span class="font-bold font-mono text-slate-900 dark:text-white">
              {{ getOfferDuration(offer) }} jornadas
            </span>
          </div>
          <div class="flex justify-between items-center pt-1 border-t border-slate-200 dark:border-slate-800">
            <span class="text-slate-500 dark:text-slate-400">Ingreso inicial del contrato:</span>
            <span class="font-bold font-mono text-emerald-700 dark:text-emerald-400 text-sm">
              {{ formatAmount(getOfferFixedAmount(offer)) }}
            </span>
          </div>
          <div class="flex justify-between items-center pt-1 border-t border-slate-200 dark:border-slate-800">
            <span class="text-slate-500 dark:text-slate-400">Bonus por victoria:</span>
            <span class="font-bold font-mono text-slate-900 dark:text-white">
              {{ getOfferWinBonusAmount(offer) !== null ? formatAmount(getOfferWinBonusAmount(offer)) : 'Sin bonus' }}
            </span>
          </div>
        </div>

        <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-relaxed italic">
          {{ game.t('sponsors.modal_desc') }}
        </p>

        <!-- Banner de error si falla la contratación -->
        @if (contractError(); as err) {
        <div
          class="p-3 bg-rose-50 dark:bg-rose-950/60 border border-rose-200 dark:border-rose-800 rounded-xl text-rose-700 dark:text-rose-300 text-xs flex items-start gap-2">
          <app-icon name="alert-triangle" [size]="16" class="shrink-0 mt-0.5" />
          <div class="space-y-1">
            <div class="font-semibold">{{ err }}</div>
            <p class="text-[11px]">
              Si la oferta ya no está disponible o el tipo se ha ocupado, la pantalla se actualizará automáticamente.
            </p>
          </div>
        </div>
        }
      </div>

      <div class="flex items-center justify-end gap-2.5 pt-2 border-t border-slate-100 dark:border-slate-800">
        <button type="button" (click)="closeSponsorModal()" [disabled]="isSubmittingSponsorContract()"
          class="px-4 py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-xl text-xs font-semibold transition-colors cursor-pointer disabled:opacity-50">
          Cancelar
        </button>

        <button type="button" id="confirm-contract-sponsor-btn" (click)="confirmSponsorContract()"
          [disabled]="!game.canAction('signSponsor') || (isSubmittingSponsorContract())"
          class="px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-xs font-semibold shadow-xs transition-colors cursor-pointer disabled:opacity-50 flex items-center gap-1.5">
          <app-icon name="check-circle" [size]="14" [class.animate-spin]="isSubmittingSponsorContract()" />
          <span>{{ game.t('sponsors.modal_confirm') }}</span>
        </button>
      </div>
    </div>
  </div>
  }

  <!-- MODAL DE CONFIRMACIÓN DE PRESUPUESTO Y CONTRATACIÓN -->
  @if (activeQuote(); as quote) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs transition-opacity"
    role="dialog" aria-modal="true">
    <div
      class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl max-w-lg w-full p-6 shadow-2xl space-y-5 text-slate-900 dark:text-white">
      <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
        <div class="flex items-center gap-2">
          <app-icon name="clipboard-check" [size]="20" class="text-emerald-600 dark:text-emerald-400" />
          <h3 class="text-base font-bold">{{ game.t('stadium.quote_modal_title') }}</h3>
        </div>
        <button type="button" (click)="closeQuoteModal()" [disabled]="isSubmittingUpgrade()"
          class="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer disabled:opacity-50">
          <app-icon name="x" [size]="18" />
        </button>
      </div>

      <div class="space-y-3 text-xs">
        <div
          class="p-4 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2.5">
          <div class="flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">Módulo a remodelar:</span>
            <span class="font-bold font-mono">{{ getModuleTitle(quote.module) }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">Código de mejora:</span>
            <span class="font-mono text-slate-700 dark:text-slate-300">{{ quote.upgradeCode }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">Coste presupuestado (quotedCost):</span>
            <span class="font-bold font-mono text-emerald-700 dark:text-emerald-400 text-sm">
              {{ ((quote.quotedCost / 1_000_000)).toFixed(2) }} M€
            </span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-slate-500 dark:text-slate-400">Duración estimada:</span>
            <span class="font-bold">
              {{ quote.durationMatchdays }} {{ quote.durationMatchdays === 1 ? 'jornada' : 'jornadas' }}
            </span>
          </div>

          @if (quote.capacity !== null && quote.capacity !== undefined) {
          <div class="flex justify-between items-center pt-1 border-t border-slate-200 dark:border-slate-800">
            <span class="text-slate-500 dark:text-slate-400">Aforo resultante (capacity):</span>
            <span class="font-bold font-mono text-slate-900 dark:text-white">
              {{ quote.capacity.toLocaleString() }} espectadores
            </span>
          </div>
          }

          @if (quote.fromLevel !== null && quote.fromLevel !== undefined && quote.toLevel !== null && quote.toLevel !==
          undefined) {
          <div class="flex justify-between items-center pt-1 border-t border-slate-200 dark:border-slate-800">
            <span class="text-slate-500 dark:text-slate-400">Salto de nivel:</span>
            <span class="font-bold font-mono text-slate-900 dark:text-white">
              Nivel {{ quote.fromLevel }} → Nivel {{ quote.toLevel }}
            </span>
          </div>
          }
        </div>

        <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-relaxed italic">
          {{ game.t('stadium.quote_warning') }}
        </p>

        <!-- Banner de error si falla la contratación -->
        @if (quoteError()) {
        <div
          class="p-3 bg-rose-50 dark:bg-rose-950/60 border border-rose-200 dark:border-rose-800 rounded-xl text-rose-700 dark:text-rose-300 text-xs flex items-start gap-2">
          <app-icon name="alert-triangle" [size]="16" class="shrink-0 mt-0.5" />
          <div class="space-y-1">
            <div class="font-semibold">{{ quoteError() }}</div>
            @if (canRetryLastContract()) {
            <p class="text-[11px]">
              Puedes reintentar de forma segura conservando el mismo identificador de operación.
            </p>
            }
          </div>
        </div>
        }
      </div>

      <div class="flex items-center justify-end gap-2.5 pt-2 border-t border-slate-100 dark:border-slate-800">
        <button type="button" (click)="closeQuoteModal()" [disabled]="isSubmittingUpgrade()"
          class="px-4 py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 rounded-xl text-xs font-semibold transition-colors cursor-pointer disabled:opacity-50">
          Cerrar
        </button>

        @if (canRetryLastContract()) {
        <button type="button" id="retry-upgrade-btn" (click)="retryLastContractRequest()"
          [disabled]="!game.canAction('upgradeClub') || (isSubmittingUpgrade())"
          class="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-xl text-xs font-semibold shadow-xs transition-colors cursor-pointer disabled:opacity-50 flex items-center gap-1.5">
          <app-icon name="rotate-ccw" [size]="14" [class.animate-spin]="isSubmittingUpgrade()" />
          <span>{{ game.t('stadium.retry_btn') }}</span>
        </button>
        } @else {
        <button type="button" id="confirm-upgrade-btn" (click)="confirmAndContractUpgrade()"
          [disabled]="!game.canAction('upgradeClub') || (isSubmittingUpgrade())"
          class="px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-xs font-semibold shadow-xs transition-colors cursor-pointer disabled:opacity-50 flex items-center gap-1.5">
          <app-icon name="check-circle" [size]="14" [class.animate-spin]="isSubmittingUpgrade()" />
          <span>{{ game.t('stadium.quote_confirm_btn') }}</span>
        </button>
        }
      </div>
    </div>
  </div>
  }
</div>
